// extracted by mini-css-extract-plugin
export var container = "_9l-0";
export var icon = "_9l-1";
export var text = "_9l-2";